<template>
	<div class="chat-container">
		<button v-if="!isHide && visible" class="btn-ripple-effect flex justify-center items-center chat-cancel-button" @click.prevent="hide">
			<transition name="fade" mode="out-in" appear>
				<SVGIcon icon-name="cancel" width="7px" height="7px" />
			</transition>
		</button>
	</div>
</template>

<script>
import SVGIcon from '~/components/interface/SVGIcon'

export default {
	name: 'Chat',
	components: { SVGIcon },
	data: () => ({ isHide: false }),
	computed: {
		visible () {
			const chatBot = document.getElementById('zsiq_float')

			return Boolean(chatBot) && chatBot?.style.display !== 'none'
		}
	},
	methods: {
		hide () {
			const chatBot = document.getElementById('zsiq_float')

			if (chatBot) {
				chatBot.style.transition = '.2s'
				chatBot.style.opacity = '0'
				setTimeout(function () { chatBot.style.display = 'none' }, 500)
			}

			this.isHide = true
		}
	}
}
</script>

<style lang="scss">
.chat-container {
	position: fixed;
	bottom: 110px;
	right: 10px;
	z-index: 50;
	.chat-cancel-button {
		height: 15px;
		width: 15px;
		border-radius: 50%;
		background-color: #004890;
		border: 1px solid #0066cc;
		&:hover {
			background-color: #0066cc;
			border: 1px solid #004890;
		}
	}
}
</style>
